import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './reports.css';

//Includes
import { COMMON, REPORTS_SCREEN, ALL_ROUTES } from '../../global/Constants';
import Utilities from '../../global/Utilities';
import { HeaderTypes } from '../../global/Enum';
import ApiServices from '../../providers/ApiServices';
import AuthService from '../../providers/AuthService';

//Components
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import SyncLoader from '../common/loader/SyncLoader';
//import Loader from '../common/loader/Loader';
import PercentLoader from '../common/loader/PercentLoader';

//Packages
import Select from 'react-select';
import moment from 'moment';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
//import SyncServices from '../../providers/SyncServices';
require('datatables.net');


class UserStatusReport extends Component {
    constructor(props) {
        super(props)
        this.datatable = null;
        this.tableRef = React.createRef();

        this.state = {
            type1: 'text',
            type2: 'text',
            allCropGroupData: [],
            allCropData: [],
            allStatesData: [],
            allDistrictsData: [],
            allTehsilsData: [],
            allVillagesData: [],
            selectedState: null,
            selectedDistrict: null,
            selectedTehsil: null,
            selectedVillage: null,
            selectedCropGroup: null,
            selectedCrop: null,
            users: [],
            selectedUser: null,
            isLoading: false,
            fields: {
                fromDate: "",
                toDate: "",
                mobile: ""
            },
            regexp: /^[0-9\b]+$/,
            pageNo: 1,
            pageSize: 10,
            allData: [],
            percent: 0,
            totalCount: 0
        }
    }

    componentDidMount() {
        const session = AuthService.getSession();
        if (session) {
            this.getAllStates();
            this.getAllCropGroup();
            this.getUserReportingUsers();
            this.initializeDataTable();
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    initializeDataTable() {
        this.$el = $(this.el);
        this.dataTable = this.$el.DataTable({
            columns: [
                { title: "From Date" },
                { title: "To Date" },
                { title: "State" },
                { title: "Crop Group" },
                { title: "Crop" },
                { title: "Employee" },
                { title: "Status" },
            ],
            order: [],
            rowCallback: function (row, data) {
                $(row).css("font-size", "16px");
            },
        });

        $(this.$el.current).on('click', '.status', function () {
            // Handle the click event for download
            console.log('Download clicked');
            // Add your logic here for the download action
        });

        this.getUserReports();
    }

    getUserReports() {
        this.setState({ isLoading: true });

        var body = JSON.stringify({
            page: 1,
            perPage: 100,
        });
        try {
            ApiServices.getUserStatusReports(body).then(response => {
                var status = response.success;
                Utilities.LogPrint("getUserReports ===>", response);
                this.setState({ isLoading: false });
                if (status) {
                    const newArrayOfObj = response.data.data;
                    let tempMainArray = [];

                    for (var i = 0; i < newArrayOfObj.length; i++) {
                        const obj = newArrayOfObj[i];
                        let tempArray = [];

                        const fromDate = moment(obj.from_date).format("DD-MM-YYYY");
                        const toDate = moment(obj.to_date).format("DD-MM-YYYY");

                        tempArray.push(fromDate);
                        tempArray.push(toDate);
                        tempArray.push(obj.statName);
                        tempArray.push(obj.cropGroupName);
                        tempArray.push(obj.cropName);
                        tempArray.push(obj.reportingUserName);

                        let status = '';
                        if (obj.status === 0 || obj.status === 1) {
                            status = `<b style="color: orange;" }}>In-progress</b>`;
                        } else if (obj.status === 2) {
                            status = `<u class="status" style="cursor: pointer;  color: green;" }}>Download</u>`;
                            //status = `${Utilities.getDownloadButton('Download')}`;

                        } else {
                            status = `<b style="color: red;" }}>Fail</b>`;
                            //status = '\u274C Fail';
                        }
                        tempArray.push(status);
                        tempArray.push(obj.download_url);

                        tempMainArray.push(tempArray);
                    }
                    this.dataTable.clear();
                    this.dataTable.rows.add(tempMainArray);
                    this.dataTable.draw();
                    Utilities.LogPrint("userReport", newArrayOfObj);

                    // Wait for the DataTable to render before setting up the click event
                    setTimeout(() => {
                        $(this.dataTable.table().body()).on('click', '.status', (event) => {
                            const clickedRow = this.dataTable.row($(event.currentTarget).closest('tr'));

                            // Get the data from the clicked row
                            const rowData = clickedRow.data();
                            const downloadUrl = rowData['7'];
                            Utilities.LogPrint("downloadUrl ===>", downloadUrl);
                            window.open(downloadUrl, '_blank');
                        });
                    }, 0);
                } else {
                    Utilities.LogPrint("userReport", response);
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }


            }).catch(error => {
                this.setState({ isLoading: false });
                Utilities.LogPrint("userReport", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("userReport", error);
        }
    }

    // initializeDataTable() {
    //     this.$el = $(this.el);
    //     this.dataTable = this.$el.DataTable({
    //         columns: [
    //             { title: COMMON.FDO_TM_NAME },
    //             { title: COMMON.REPORTING_MANAGER },
    //             { title: COMMON.MOBILE_NUMBER },
    //             //{ title: COMMON.DATE_OF_JOINING },
    //             { title: COMMON.ROLE },
    //             //{ title: COMMON.ACTIVE_INACTIVE },
    //             { title: COMMON.NO_OF_DAYS_ACTIVE },
    //             { title: COMMON.SELF_PLANNED },
    //             { title: COMMON.ASSIGNED_BY_MANAGER },
    //             { title: COMMON.SELF_PLANED_COMPLETED },
    //             { title: COMMON.ASSIGNED_BY_MANAGER_COMPLETED },
    //             { title: COMMON.TOTAL_COMPLETED },
    //             { title: COMMON.TOTAL_PENDING },
    //             // { title: COMMON.PLANNED },
    //             // { title: COMMON.ASSIGNED },
    //             // { title: COMMON.COMPLETED },
    //         ]
    //     });

    //     var dataTableKrishak = this.dataTable;

    //     $(document).ready(function () {

    //         $('#krishakReport thead tr').clone(true).appendTo('#krishakReport thead');
    //         $('#krishakReport thead tr:eq(1) th').each(function (i) {

    //             var title = $(this).text();
    //             $(this).html('<input type="text" placeholder="Search ' + title + '" />');

    //             $('input', this).on('keyup change', function () {
    //                 if (dataTableKrishak.column(i).search() !== this.value) {
    //                     dataTableKrishak
    //                         .column(i)
    //                         .search(this.value)
    //                         .draw();
    //                 }
    //             });
    //         });
    //     });
    // }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {

        if (field === "mobile") {
            let telephone = e.target.value;
            if (telephone === '' || this.state.regexp.test(telephone)) {
                let fields = this.state.fields;
                fields[field] = telephone;
                this.setState({ fields });
            }
        } else {
            let fields = this.state.fields;
            fields[field] = e.target.value;
            this.setState({ fields });
        }
    };

    updateNextButton() {
        const toDate = moment(this._getFieldValue("toDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        const fromDate = moment(this._getFieldValue("fromDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        if (toDate !== "Invalid date" && fromDate !== "Invalid date") {
            //this.userReport();

            //this.setState({ allData: [], page: 1 });
            //this.fetchData();
        }
    }

    createUserReport = async () => {
        this.setState({ isLoading: true });
        const { selectedCrop, selectedCropGroup, selectedState, selectedTehsil, selectedVillage, selectedDistrict, pageNo, pageSize, selectedUser } = this.state;
        const mobile = this._getFieldValue("mobile", "");
        const toDate = moment(this._getFieldValue("toDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        const fromDate = moment(this._getFieldValue("fromDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        var body = JSON.stringify({
            page: pageNo,
            perPage: pageSize,
            searchKey: "",
            sortBy: "state_name",
            sortOrder: "DESC",
            from_date: fromDate,
            to_date: toDate,
            state_id: selectedState ? selectedState.value : [],
            village_id: selectedVillage ? selectedVillage.value : [],
            district_id: selectedDistrict ? selectedDistrict.value : [],
            tehsil_id: selectedTehsil ? selectedTehsil.value : [],
            phone: mobile,
            crop_id: selectedCrop ? selectedCrop.value : 0,
            crop_group_id: selectedCropGroup ? selectedCropGroup.value : 0,
            report_user_id: selectedUser !== null ? selectedUser.value : 0
        });

        try {
            ApiServices.userReport(body).then(async response => {

                var status = await response.success;
                Utilities.LogPrint("userReport", response);
                if (status) {
                    let data = response.data;
                    if (data !== null) {
                        this.getUserReports();
                    }
                } else {
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }
            }).catch(error => {
                this.setState({ isLoading: false });
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }


    fetchData = async () => {
        this.setState({ isLoading: true });
        const { selectedCrop, selectedCropGroup, selectedState, selectedTehsil, selectedVillage, selectedDistrict, pageNo, pageSize, selectedUser } = this.state;
        const mobile = this._getFieldValue("mobile", "");
        const toDate = moment(this._getFieldValue("toDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        const fromDate = moment(this._getFieldValue("fromDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        var body = JSON.stringify({
            page: pageNo,
            perPage: pageSize,
            searchKey: "",
            sortBy: "state_name",
            sortOrder: "DESC",
            from_date: fromDate,
            to_date: toDate,
            state_id: selectedState ? selectedState.value : [],
            village_id: selectedVillage ? selectedVillage.value : [],
            district_id: selectedDistrict ? selectedDistrict.value : [],
            tehsil_id: selectedTehsil ? selectedTehsil.value : [],
            phone: mobile,
            crop_id: selectedCrop ? selectedCrop.value : 0,
            crop_group_id: selectedCropGroup ? selectedCropGroup.value : 0,
            report_user_id: selectedUser !== null ? selectedUser.value : 0
        });

        try {
            ApiServices.userReport(body).then(async response => {

                var status = await response.success;
                Utilities.LogPrint("userReport", response);
                if (status) {
                    let data = response.data;
                    if (data !== null) {
                        let totalCount = this.state.totalCount;
                        if (data.page_no === 1) {
                            totalCount = data?.count;
                        }

                        const calculatedPercent = this.calculatePercent(totalCount);

                        this.setState((prevState, props) => ({
                            allData: [...this.state.allData, ...data.data],
                            pageNo: prevState.pageNo + 1,
                            totalCount: totalCount,
                            percent: calculatedPercent
                        }), () => {
                            const { totalCount, allData } = this.state;
                            if (totalCount !== allData.length) {
                                this.fetchData();
                            } else {
                                this.setState({ isLoading: false });
                                this.downloadReport();
                            }
                        });
                    }
                } else {
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }
            }).catch(error => {
                this.setState({ isLoading: false });
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    calculatePercent = (totalCount) => {
        if (totalCount) {
            let avg = totalCount / this.state.pageSize;
            return (Math.round(100 / avg) + this.state.percent);
        }
        return 0;
    }

    downloadReport = () => {
        const { allData } = this.state;

        if (allData.length > 0) {
            let headers = ['Name,Role,Reporting Manager,Mobile Number,Active/In-Active,Days Active,Self Planned,Assigned By Manager,Self Planned Completed,Assigned By Manager Completed,Total Completed,Total Pending,IV Farmer,IV Retailer,Group Meeting,Sample Distribution,Sample To Sale,Krishak,Prerak',];

            // Convert villages data to a csv
            let reportCsv = allData.reduce((acc, item) => {
                const { name, role_name, reporting_manager, phone, is_active, no_of_active, self_planed, assigned_by_manager, self_planed_completed, assigned_by_manager_completed, total_completed, total_pendding, iv_farmer_count, iv_retailer_count, gm_count, sd_count, sts_count, krishak_count, prerak_count } = item
                acc.push([name, role_name, reporting_manager, phone, is_active, no_of_active, self_planed, assigned_by_manager, self_planed_completed, assigned_by_manager_completed, total_completed, total_pendding, iv_farmer_count, iv_retailer_count, gm_count, sd_count, sts_count, krishak_count, prerak_count].join(','))
                return acc
            }, []);

            this.setState({
                loading: false,
                allData: [],
                pageNo: 1,
                percent: 0,
                totalCount: 0
            });

            this.downloadFile({
                data: [...headers, ...reportCsv].join('\n'),
                fileName: 'UserStatus.csv',
                fileType: 'text/csv',
            })
        }
    }

    downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    userReport = () => {
        this.setState({ isLoading: true });
        const { selectedCrop, selectedCropGroup, selectedState, selectedTehsil, selectedVillage, selectedDistrict } = this.state;
        const mobile = this._getFieldValue("mobile", "");
        const toDate = moment(this._getFieldValue("toDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        const fromDate = moment(this._getFieldValue("fromDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        var body = JSON.stringify({
            page: 1,
            perPage: 20,
            searchKey: "",
            sortBy: "state_name",
            sortOrder: "DESC",
            from_date: fromDate,
            to_date: toDate,
            state_id: selectedState ? [selectedState.value] : [],
            village_id: selectedVillage ? [selectedVillage.value] : [],
            district_id: selectedDistrict ? [selectedDistrict.value] : [],
            tehsil_id: selectedTehsil ? [selectedTehsil.value] : [],
            phone: mobile,
            crop_id: selectedCrop ? [selectedCrop.value] : 0,
            crop_group_id: selectedCropGroup ? [selectedCropGroup.value] : 0,
        });
        try {
            ApiServices.userReport(body).then(response => {
                var status = response.success;
                Utilities.LogPrint("userReport", response);
                this.setState({ isLoading: false });
                if (status) {
                    const newArrayOfObj = response.data.data;
                    let tempMainArray = [];

                    for (var i = 0; i < newArrayOfObj.length; i++) {
                        const obj = newArrayOfObj[i];
                        let tempArray = [];

                        tempArray.push(obj.name);
                        tempArray.push(obj.reporting_manager);
                        tempArray.push(obj.phone);

                        tempArray.push(obj?.role_name ? obj?.role_name : "");
                        //tempArray.push(obj.is_active === 1 ? COMMON.YES : COMMON.NO);
                        tempArray.push(obj.no_of_active);
                        //tempArray.push(obj.no_active_days);
                        tempArray.push(obj.self_planed);
                        tempArray.push(obj.assigned_by_manager);
                        tempArray.push(obj.self_planed_completed);
                        tempArray.push(obj.assigned_by_manager_completed);
                        tempArray.push(obj.total_completed);
                        tempArray.push(obj.total_pendding);
                        //tempArray.push(obj.planned_activity_no);
                        //tempArray.push(obj.assigned_activity_no);
                        //tempArray.push(obj.completed_activity_no);

                        tempMainArray.push(tempArray);
                    }
                    //Utilities.LogPrint("convertedDataForDatatables435", tempMainArray);
                    this.dataTable.clear();
                    this.dataTable.rows.add(tempMainArray);
                    this.dataTable.draw();
                    Utilities.LogPrint("userReport", newArrayOfObj);

                } else {
                    Utilities.LogPrint("userReport", response);
                    if (response.message === COMMON.TOKEN_EXPIRED) {
                        Utilities.tokenExpiredRedirectToLogin();
                    }
                }
            }).catch(error => {
                this.setState({ isLoading: false });
                Utilities.LogPrint("userReport", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("userReport", error);
        }
    }

    getAllActiveCrop = (id) => {
        this.setState({ allCropData: [], selectedCrop: null });
        let params = JSON.stringify({
            crop_group_id: id
        })
        try {
            ApiServices.getUserCrop(params)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allCropData: data.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllCropGroup = () => {
        try {
            ApiServices.getUserCropGroup("")
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allCropGroupData: data.map(({ crop_group_id: value, crop_group_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllStates = () => {
        try {
            ApiServices.getUserState("")
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allStatesData: data.map(({ state_id: value, state_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }
    }

    getAllDistricts = (selectedState) => {
        let request = JSON.stringify({
            state_id: selectedState.value
        })

        try {
            ApiServices.getAllActiveDistrict(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allDistrictsData: data.map(({ district_id: value, district_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }
    }

    getAllTehsils = (selectedDistrict) => {
        let request = JSON.stringify({
            district_id: selectedDistrict.value
        })
        try {
            ApiServices.getActiveTehsilByDistrictId(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allTehsilsData: data.map(({ tehsil_id: value, tehsil_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getAllVillageById = (selectedTehsil) => {
        let request = JSON.stringify({
            tehsil_id: selectedTehsil.value
        })
        try {
            ApiServices.getAllVillageByUser(request)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                allVillagesData: data.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    getUserReportingUsers = () => {
        try {
            ApiServices.getUserReportingUserDetails("")
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    //this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data && data.length > 0) {
                            this.setState({
                                users: data.map(({ user_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    //this.setState({ isLoading: false });
                });
        } catch (error) {
            //this.setState({ isLoading: false });
        }
    }

    handleStateChange = selectedState => {
        if (selectedState === null) {
            this.setState({
                selectedState: null,
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedState, selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null
            });
            this.getAllDistricts(selectedState);
        }
        this.setState({ allDistrictsData: [], allTehsilsData: [], allVillagesData: [] });
    };

    handleDistrictChange = selectedDistrict => {
        if (selectedDistrict === null) {
            this.setState({
                selectedDistrict: null,
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({
                selectedDistrict, selectedTehsil: null,
                selectedVillage: null
            });
            this.getAllTehsils(selectedDistrict);
        }
        this.setState({ allTehsilsData: [], allVillagesData: [] });
    };

    handleTehsilChange = selectedTehsil => {
        if (selectedTehsil === null) {
            this.setState({
                selectedTehsil: null,
                selectedVillage: null,
            });
        } else {
            this.setState({ selectedTehsil, selectedVillage: null });
            this.getAllVillageById(selectedTehsil);
        }
        this.setState({ allVillagesData: [] });
    };

    handleVillageChange = selectedVillage => {
        if (selectedVillage === null) {
            this.setState({
                selectedVillage: null,
            });
        } else {
            this.setState({ selectedVillage });
        }
    };

    handleCropChange = selectedCrop => {
        this.setState({ selectedCrop });
    };

    handleCropGroupChange = selectedCropGroup => {

        this.setState({ selectedCropGroup });
        if (selectedCropGroup) {
            this.getAllActiveCrop(selectedCropGroup.value);
        } else {
            this.setState({ allCropData: [], selectedCrop: null })
        }
    };

    handleUserChange = selectedUser => {
        this.setState({ selectedUser });
    };

    onFocus = (event, fieldName) => {
        event.preventDefault();
        if (fieldName === "fromDate") {
            this.setState({
                type1: 'date',
            });
        } else {
            this.setState({
                type2: 'date',
            });
        }
    }

    onBlur = (event, fieldName) => {
        event.preventDefault();
        let fields = this.state.fields;
        fields[fieldName] = moment(this._getFieldValue(fieldName, ""), "YYYY-MM-DD").format("DD-MM-YYYY");
        this.setState({
            type1: 'text',
            type2: 'text',
            fields
        });
    }


    handleDataPrint = () => {

        const toDate = moment(this._getFieldValue("toDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");
        const fromDate = moment(this._getFieldValue("fromDate", ""), "DD-MM-YYYY").format("YYYY-MM-DD");

        if (fromDate === 'Invalid date' || toDate === 'Invalid date') {
            alert("Please Select From and To Date");
            return;
        }

        this.createUserReport();

        //Download Report From Front-end with pagination
        //this.fetchData();

        //Download Report Backend 
        // this.setState({ isLoading: true });
        // const { selectedCrop, selectedCropGroup, selectedState, selectedTehsil, selectedVillage, selectedDistrict } = this.state;

        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "state_name",
        //     sortOrder: "DESC",
        //     from_date: fromDate,
        //     to_date: toDate,
        //     state_id: selectedState ? [selectedState.value] : [],
        //     village_id: selectedVillage ? [selectedVillage.value] : [],
        //     district_id: selectedDistrict ? [selectedDistrict.value] : [],
        //     tehsil_id: selectedTehsil ? [selectedTehsil.value] : [],
        //     phone: mobile,
        //     crop_id: selectedCrop ? [selectedCrop.value] : 0,
        //     crop_group_id: selectedCropGroup ? [selectedCropGroup.value] : 0,
        // });

        // try {
        //     ApiServices.exportUserReport(body).then(response => {
        //         this.setState({ isLoading: false });
        //         Utilities.downloadBlob(response, "UserStatus.xls");
        //     }).catch(error => {
        //         this.setState({ isLoading: false });
        //         Utilities.LogPrint("getActivityReport", error);
        //     });
        // } catch (error) {
        //     this.setState({ isLoading: false });
        //     Utilities.LogPrint("getActivityReport", error);
        // }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const fromDate = this._getFieldValue("fromDate", "");
        const toDate = this._getFieldValue("toDate", "");
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, allCropData, allCropGroupData, selectedCrop, selectedCropGroup, allStatesData, allDistrictsData, allTehsilsData, allVillagesData, selectedState, selectedDistrict, selectedTehsil, selectedVillage, users, selectedUser } = this.state;

        return (
            <div>
                <Header selectedTab={HeaderTypes.REPORTS} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-md-6">
                            <h1>{REPORTS_SCREEN.USER_STATUS_REPORT}</h1>
                        </div>

                        <div className="col-lg-6 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary"
                                onClick={this.handleDataPrint}>
                                <i className="icon print" />
                                {/* {COMMON.DOWNLOAD} */}
                                Generate Report
                            </button>
                        </div>

                        {/* <div className="col-lg-6 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary" onClick={this.handleDataPrint}><i className="customic print" />{COMMON.DOWNLOAD}</button>
                        </div> */}
                    </div>
                    {/* <form> */}
                    <form action="">
                        <div className="row mt-4">
                            <div className="col-md-3 col-12">
                                <div className="form-group input-date">
                                    <input type={this.state.type1} min={moment().subtract(74, 'years').format("YYYY-MM-DD")} max={moment().format("YYYY-MM-DD")} id="fromDate" className="form-control mb-0" onFocus={(e) => this.onFocus(e, "fromDate")} onBlur={(e) => this.onBlur(e, "fromDate")} onChange={this._handleValueChange.bind(this, "fromDate")} placeholder={COMMON.FROM_DATE} value={fromDate} />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group input-date">
                                    <input type={this.state.type2} min={moment().subtract(74, 'years').format("YYYY-MM-DD")} max={moment().format("YYYY-MM-DD")} id="toDate" className="form-control mb-0" onFocus={(e) => this.onFocus(e, "toDate")} onBlur={(e) => this.onBlur(e, "toDate")} onChange={this._handleValueChange.bind(this, "toDate")} placeholder={COMMON.TO_DATE} value={toDate} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedState}
                                        onChange={this.handleStateChange}
                                        options={allStatesData}
                                        placeholder={COMMON.STATE}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedDistrict}
                                        onChange={this.handleDistrictChange}
                                        options={allDistrictsData}
                                        placeholder={COMMON.DISTRICT}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedTehsil}
                                        onChange={this.handleTehsilChange}
                                        options={allTehsilsData}
                                        placeholder={COMMON.TEHSIL}
                                        isClearable={true}
                                    />

                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedVillage}
                                        onChange={this.handleVillageChange}
                                        options={allVillagesData}
                                        placeholder={COMMON.VILLAGE}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedCropGroup}
                                        onChange={this.handleCropGroupChange}
                                        options={allCropGroupData}
                                        placeholder={COMMON.SELECT_CROP_GROUP}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedCrop}
                                        onChange={this.handleCropChange}
                                        options={allCropData}
                                        placeholder={COMMON.SELECT_CROP}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-12 mb-3">
                                <div className="form-group">
                                    <Select className=" max-w-360"
                                        value={selectedUser}
                                        onChange={this.handleUserChange}
                                        options={users}
                                        placeholder={COMMON.SELECT_USER}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>

                    <table
                        id="krishakReport"
                        ref={(el) => (this.el = el)}
                        className="display table table-responsive table-striped table-bordered mobile-number">
                    </table>

                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {/* {isLoading ? <Loader /> : null} */}

                {isLoading ? <PercentLoader progress={this.state.percent} /> : null}

                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(UserStatusReport)